"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType[EventType["DotnetAcquisitionStart"] = 0] = "DotnetAcquisitionStart";
    EventType[EventType["DotnetSDKAcquisitionStart"] = 1] = "DotnetSDKAcquisitionStart";
    EventType[EventType["DotnetRuntimeAcquisitionStart"] = 2] = "DotnetRuntimeAcquisitionStart";
    EventType[EventType["DotnetASPNetRuntimeAcquisitionStarted"] = 3] = "DotnetASPNetRuntimeAcquisitionStarted";
    EventType[EventType["DotnetAcquisitionCompleted"] = 4] = "DotnetAcquisitionCompleted";
    EventType[EventType["DotnetAcquisitionError"] = 5] = "DotnetAcquisitionError";
    EventType[EventType["DotnetAcquisitionFinalError"] = 6] = "DotnetAcquisitionFinalError";
    EventType[EventType["DotnetAcquisitionSuccessEvent"] = 7] = "DotnetAcquisitionSuccessEvent";
    EventType[EventType["DotnetAcquisitionMessage"] = 8] = "DotnetAcquisitionMessage";
    EventType[EventType["DotnetAcquisitionTest"] = 9] = "DotnetAcquisitionTest";
    EventType[EventType["DotnetAcquisitionAlreadyInstalled"] = 10] = "DotnetAcquisitionAlreadyInstalled";
    EventType[EventType["DotnetAcquisitionInProgress"] = 11] = "DotnetAcquisitionInProgress";
    EventType[EventType["DotnetUninstallMessage"] = 12] = "DotnetUninstallMessage";
    EventType[EventType["DotnetDebuggingMessage"] = 13] = "DotnetDebuggingMessage";
    EventType[EventType["DotnetTotalSuccessEvent"] = 14] = "DotnetTotalSuccessEvent";
    EventType[EventType["OfflineInstallUsed"] = 15] = "OfflineInstallUsed";
    EventType[EventType["OfflineWarning"] = 16] = "OfflineWarning";
    EventType[EventType["DotnetUpgradedEvent"] = 17] = "DotnetUpgradedEvent";
    EventType[EventType["SuppressedAcquisitionError"] = 18] = "SuppressedAcquisitionError";
    EventType[EventType["DotnetVisibleWarning"] = 19] = "DotnetVisibleWarning";
    EventType[EventType["DotnetInstallExpectedAbort"] = 20] = "DotnetInstallExpectedAbort";
    EventType[EventType["DotnetModalChildEvent"] = 21] = "DotnetModalChildEvent";
    // Example: DotnetAcquisitionStarted -> Children events are RuntimeStarted, SDKStarted, etc.
    EventType[EventType["FeedInjectionMessage"] = 22] = "FeedInjectionMessage";
})(EventType || (exports.EventType = EventType = {}));
//# sourceMappingURL=EventType.js.map